import {Links} from './links.model';
import {PagedHal} from './paged-hal.model';

export class Member {
  email: string;
  role: string;
  state: State;
  _links: Links;

  constructor(data: any) {
    this.email = data.email;
    this.role = data.role;
    this.state = data.state;
    this._links = new Links(data._links)
  }
}

export enum State {
  ACTIVE = "ACTIVE",
  PENDING = "PENDING"
}

class Embedded {
  members: Member[];

  constructor(data: any) {
    this.members = data.members.map((data: any) => new Member(data));
  }
}

export class MemberHal extends PagedHal {
  _embedded?: Embedded;

  constructor(data: any) {
    super(data);
    if (!!data._embedded) {
      this._embedded = new Embedded(data._embedded);
    }
  }
}
